import React from "react";

export const SocTwitterIcon = () => {
  return (
    <svg
      width="23"
      height="19"
      viewBox="0 0 23 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.2998 2.64348C21.5012 2.99846 20.6417 3.23791 19.7399 3.34506C20.6607 2.79385 21.3667 1.92072 21.6996 0.879148C20.8384 1.39023 19.885 1.76109 18.8694 1.96129C18.0567 1.09522 16.8983 0.553711 15.6164 0.553711C13.1553 0.553711 11.1599 2.54911 11.1599 5.01061C11.1599 5.35942 11.1992 5.69941 11.2755 6.02617C7.5713 5.84008 4.28695 4.06605 2.0887 1.36951C1.70506 2.02744 1.48546 2.79296 1.48546 3.61053C1.48546 5.15657 2.27215 6.52094 3.46806 7.31998C2.73781 7.29661 2.05034 7.09597 1.4493 6.76215C1.44885 6.78067 1.44885 6.79963 1.44885 6.81859C1.44885 8.97759 2.9852 10.7785 5.02425 11.1886C4.65031 11.29 4.25652 11.3447 3.84994 11.3447C3.56243 11.3447 3.2833 11.3169 3.01122 11.2645C3.57875 13.035 5.22445 14.3239 7.17443 14.3596C5.64911 15.5551 3.7278 16.2677 1.63935 16.2677C1.27996 16.2677 0.92498 16.2466 0.576172 16.2051C2.54908 17.4703 4.89152 18.2076 7.40814 18.2076C15.6062 18.2076 20.0887 11.4166 20.0887 5.52699C20.0887 5.33384 20.0848 5.14114 20.0764 4.94976C20.9469 4.3227 21.7027 3.53732 22.2998 2.64348Z"
        fill="inherit"
      />
    </svg>
  );
};
